import { defineStore, acceptHMRUpdate } from 'pinia';
import { storeConfigWithoutPersist } from '@/shared/storeConfig';

const featuresStore = () => {
  const isLoading = ref<boolean>(false);
  const features = ref<FeaturesFromApi[]>([]);

  function $reset() {
    isLoading.value = false;
    features.value = [];
  }

  return {
    $reset,
    isLoading,
    features,
  };
};

export const useFeaturesStore = defineStore(
  'features',
  featuresStore,
  storeConfigWithoutPersist,
);

// @ts-ignore
if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useFeaturesStore, import.meta.hot));
}
